// Types
import { RouteRecordRaw } from 'vue-router';

// Local Types
export enum RoutePath {
  CATCH_ALL = '/:catchAll(.*)*',
  CHECKOUT = '/checkout',
  HOME = '/home',
  LOGIN = '/',
  PAYMENT_CONFIRMATION = '/payment-confirmation',
  REGISTER_CAR = '/register-car/:id?',
  REGISTER_CHILD = '/register-child/:id?',
  REGISTER_CO_ENTRANT = '/register-co-entrant/:id?',
  REGISTER_GUEST = '/register-guest/:id?',
  REGISTER_PRIMARY_ENTRANT = '/register-primary-entrant/:id?',
  CALENDAR = '/calendar',
  REGISTER_STANDARD_EVENT = '/register-standard-event/:eventId?/:entrantId?',
  REGISTER_JUNIORS_AT_PARADE_EVENT = '/register-juniors-at-parade-event/:eventId?/:entrantId?',
  REGISTER_SIM_RACING_EVENT = '/register-sim-racing-event/:eventId?/:entrantId?',
  REGISTER_AUTOX_EVENT = '/register-autoX-event/:eventId?/:entrantId?',
  REGISTER_CONCOURS_EVENT = '/register-concours-event/:eventId?/:entrantId?',
  SELECT_EVENT = '/select-event',
  REGISTER_VOLUNTEER = '/register-volunteer',
  REGISTER_MEAL = '/register-meal/:mealId?/:entrantId?',
  SELECT_MEAL = '/select-meal',
}

export enum RouteName {
  CATCH_ALL = '/catch-all',
  CHECKOUT = '/checkout',
  HOME = '/home',
  LOGIN = '/login',
  PAGE_NOT_FOUND = '/page-not-found',
  PAYMENT_CONFIRMATION = '/payment-confirmation',
  REGISTER_CAR = '/register-car',
  REGISTER_CHILD = '/register-child',
  REGISTER_CO_ENTRANT = '/register-co-entrant',
  REGISTER_GUEST = '/register-guest',
  REGISTER_PRIMARY_ENTRANT = '/register-primary-entrant',
  CALENDAR = '/calendar',
  REGISTER_STANDARD_EVENT = '/register-standard-event',
  REGISTER_JUNIORS_AT_PARADE_EVENT = '/register-juniors-at-parade-event',
  REGISTER_SIM_RACING_EVENT = '/register-sim-racing-event',
  REGISTER_AUTOX_EVENT = '/register-autoX-event',
  REGISTER_CONCOURS_EVENT = '/register-concours-event',
  SELECT_EVENT = '/select-event',
  REGISTER_VOLUNTEER = '/register-volunteer',
  REGISTER_MEAL = '/register-meal',
  SELECT_MEAL = '/select-meal',
}

const routes: RouteRecordRaw[] = [
  {
    children: [],
    component: () => import('@/pages/HomePage.vue'),
    name: RouteName.HOME,
    path: RoutePath.HOME,
    meta: { requiresAuth: true }
  },
  {
    children: [],
    component: () => import('@/pages/Login.vue'),
    name: RouteName.LOGIN,
    path: RoutePath.LOGIN,
    meta: { requiresGuest: true }
  },
  {
    children: [],
    component: () => import('@/pages/RegisterCar.vue'),
    name: RouteName.REGISTER_CAR,
    meta: { requiresAuth: true },
    path: RoutePath.REGISTER_CAR,
  },
  {
    children: [],
    component: () => import('@/pages/RegisterPrimaryEntrant.vue'),
    name: RouteName.REGISTER_PRIMARY_ENTRANT,
    meta: { requiresAuth: true },
    path: RoutePath.REGISTER_PRIMARY_ENTRANT,
  },
  {
    children: [],
    component: () => import('@/pages/RegisterCoEntrant.vue'),
    name: RouteName.REGISTER_CO_ENTRANT,
    meta: { requiresAuth: true },
    path: RoutePath.REGISTER_CO_ENTRANT,
  },
  {
    children: [],
    component: () => import('@/pages/RegisterGuest.vue'),
    name: RouteName.REGISTER_GUEST,
    meta: { requiresAuth: true },
    path: RoutePath.REGISTER_GUEST,
  },
  {
    children: [],
    component: () => import('@/pages/EventsCalendar.vue'),
    name: RouteName.CALENDAR,
    meta: { requiresAuth: true },
    path: RoutePath.CALENDAR,
  },
  {
    children: [],
    component: () => import('@/pages/SelectEvent.vue'),
    name: RouteName.SELECT_EVENT,
    meta: { requiresAuth: true },
    path: RoutePath.SELECT_EVENT,
  },
  {
    children: [],
    component: () => import('@/pages/RegisterChild.vue'),
    name: RouteName.REGISTER_CHILD,
    meta: { requiresAuth: true },
    path: RoutePath.REGISTER_CHILD,
  },
  {
    children: [],
    component: () => import('@/pages/RegisterStandardEvent.vue'),
    name: RouteName.REGISTER_STANDARD_EVENT,
    meta: { requiresAuth: true },
    path: RoutePath.REGISTER_STANDARD_EVENT,
  },
  {
    children: [],
    component: () => import('@/pages/RegisterJuniorsAtParadeEvent.vue'),
    name: RouteName.REGISTER_JUNIORS_AT_PARADE_EVENT,
    meta: { requiresAuth: true },
    path: RoutePath.REGISTER_JUNIORS_AT_PARADE_EVENT,
  },
  {
    children: [],
    component: () => import('@/pages/RegisterAutoXEvent.vue'),
    name: RouteName.REGISTER_AUTOX_EVENT, 
    meta: { requiresAuth: true },
    path: RoutePath.REGISTER_AUTOX_EVENT,
  },
  {
    children: [], 
    component: () => import('@/pages/RegisterSimRacingEvent.vue'),
    name: RouteName.REGISTER_SIM_RACING_EVENT, 
    meta: { requiresAuth: true },
    path: RoutePath.REGISTER_SIM_RACING_EVENT,
  },
  {
    children: [], 
    component: () => import('@/pages/RegisterConcoursEvent.vue'),  
    name: RouteName.REGISTER_CONCOURS_EVENT, 
    meta: { requiresAuth: true },
    path: RoutePath.REGISTER_CONCOURS_EVENT,
  },
  {
    children: [],
    component: () => import('@/pages/RegisterMeal.vue'),
    name: RouteName.REGISTER_MEAL,
    meta: { requiresAuth: true },
    path: RoutePath.REGISTER_MEAL,
  },
  {
    children: [],
    component: () => import('@/pages/SelectMeal.vue'),
    name: RouteName.SELECT_MEAL,
    meta: { requiresAuth: true },
    path: RoutePath.SELECT_MEAL,
  },
  {
    children: [],
    component: () => import('@/pages/RegisterVolunteer.vue'),
    name: RouteName.REGISTER_VOLUNTEER,
    meta: { requiresAuth: true },
    path: RoutePath.REGISTER_VOLUNTEER,
  },
  {
    children: [],
    component: () => import('@/pages/Checkout.vue'),
    name: RouteName.CHECKOUT,
    meta: { requiresAuth: true },
    path: RoutePath.CHECKOUT,
  },
  {
    children: [],
    component: () => import('@/pages/PaymentConfirmation.vue'),
    name: RouteName.PAYMENT_CONFIRMATION,
    meta: { requiresAuth: true },
    path: RoutePath.PAYMENT_CONFIRMATION,
  },
  {
    component: () => import('@/pages/PageNotFound.vue'),
    name: RouteName.PAGE_NOT_FOUND,
    meta: { requiresAuth: true },
    path: RoutePath.CATCH_ALL,
  },
];

export default routes;
